import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CONFIRM_CHANGES: "Bekreft endringer",
      CONFIRM_ORDER: "Bekreft bestillingen",
      LAST_CHANCE: "Legg til noe ekstra?",
      ORDER: "Bestilling",
      SHOW_MORE: "Vis mer",
      MEALS: "middager",
      ADDONS: "dagligvarer",
      ADDON: "dagligvare",
      UNDO_CHANGES: "Angre endringer",
      PORTIONS: "porsjoner",
      SUMMARY: "Oppsummering",
      DISCOUNT: "Rabatt",
      DELIVERY: "Levering",
      TOTAL: "Totalt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuke",
      NOTIFICATION_DELIVERY_STARTED: "Dine leveranser er gjenopptatt",
      BEFORE_DISCOUNTS_ARE_APPLIED: "Før rabatter er trukket",
      YOU_MUST_HAVE_MINIMUM_MEALS_TO_RECEIVE_DELIVERY: (minMeals: number) =>
        `Du må ha minimum ${minMeals} middager for å motta leveringen.`,
    },

    se: {
      CONFIRM_CHANGES: "Bekräfta ändringar",
      CONFIRM_ORDER: "Bekräfta beställningen",
      LAST_CHANCE: "Lägg till något extra?",
      ORDER: "Beställning",
      SHOW_MORE: "Visa mer",
      MEALS: "middagar",
      ADDONS: "livsmedel",
      ADDON: "livsmedel",
      UNDO_CHANGES: "Ångra ändringar",
      PORTIONS: "portioner",
      SUMMARY: "Sammanfattning",
      DISCOUNT: "Rabatt",
      DELIVERY: "Leverans",
      TOTAL: "Totalt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan inte beställa innan startvecka",
      NOTIFICATION_DELIVERY_STARTED: "Du har nu leveranser varje vecka!",
      BEFORE_DISCOUNTS_ARE_APPLIED: "Innan rabatter är dragna",
      YOU_MUST_HAVE_MINIMUM_MEALS_TO_RECEIVE_DELIVERY: (minMeals: number) =>
        `För att vi ska kunna leverera behöver du beställa minst ${minMeals} middagar.`,
    },

    dk: {
      CONFIRM_CHANGES: "Bekræft ændringer",
      CONFIRM_ORDER: "Bekræft ordre",
      LAST_CHANCE: "Tilføj noget ekstra?",
      ORDER: "Bestilling",
      SHOW_MORE: "Vis mere",
      MEALS: "retter",
      ADDONS: "specialvarer",
      ADDON: "specialvare",
      UNDO_CHANGES: "Fortryd ændringer",
      PORTIONS: "portioner",
      SUMMARY: "Opsummering",
      DISCOUNT: "Rabat",
      DELIVERY: "Levering",
      TOTAL: "I alt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuge",
      NOTIFICATION_DELIVERY_STARTED: "Dine leveringer er startet",
      BEFORE_DISCOUNTS_ARE_APPLIED: "Før rabatten er fratrukket",
      YOU_MUST_HAVE_MINIMUM_MEALS_TO_RECEIVE_DELIVERY: (minMeals: number) =>
        `Du skal vælge mindst ${minMeals} retter for at modtage leveringen.`,
    },
  } as const
)[language];
